import { useCallback, useEffect, useRef, useState } from "react";

// Handy: Kanban-Spalten einzeln wischen + Phasen-Leiste zum Antippen.
// Position einer Spalte innerhalb des scrollbaren Boards (unabhängig vom offsetParent).
const posIn = (board, el) => el.getBoundingClientRect().left - board.getBoundingClientRect().left + board.scrollLeft;

export function useColumnSnap() {
  const boardRef = useRef(null);
  const [active, setActive] = useState(0);
  const onScroll = useCallback(() => {
    const board = boardRef.current;
    if (!board) return;
    const cols = [...board.querySelectorAll("[data-col-index]")];
    if (!cols.length) return;
    const pad = posIn(board, cols[0]);
    let best = 0;
    let dist = Infinity;
    cols.forEach((c, i) => {
      const d = Math.abs(posIn(board, c) - pad - board.scrollLeft);
      if (d < dist) { dist = d; best = i; }
    });
    setActive(best);
  }, []);
  const scrollTo = useCallback((i) => {
    const board = boardRef.current;
    const first = board?.querySelector('[data-col-index="0"]');
    const col = board?.querySelector(`[data-col-index="${i}"]`);
    if (col && first) board.scrollTo({ left: posIn(board, col) - posIn(board, first), behavior: "smooth" });
  }, []);
  return { boardRef, active, onScroll, scrollTo };
}

export default function MobileStageBar({ items, active, onPick, testid = "mobile-stage-bar" }) {
  const barRef = useRef(null);
  useEffect(() => {
    barRef.current?.querySelector(`[data-chip-index="${active}"]`)?.scrollIntoView({ inline: "center", block: "nearest", behavior: "smooth" });
  }, [active]);
  return (
    <div ref={barRef} className="sm:hidden flex gap-1.5 overflow-x-auto no-scrollbar px-4 pb-2" data-testid={testid}>
      {items.map((it, i) => (
        <button key={it.key} type="button" data-chip-index={i} onClick={() => onPick(i)} data-testid={`${testid}-chip-${it.key}`}
          className={`shrink-0 h-9 px-3 rounded-full text-[12.5px] font-semibold inline-flex items-center gap-1.5 border transition-colors ${
            i === active ? "bg-[#00E575] text-[#09090B] border-[#00E575]" : `bg-[#18181B] text-zinc-300 ${it.warn ? "border-red-500/50" : "border-zinc-700"}`
          }`}>
          {it.label}
          <span className={`font-mono text-[11px] ${i === active ? "text-[#09090B]/70" : "text-zinc-500"}`}>{it.count}</span>
        </button>
      ))}
    </div>
  );
}
